import React, { useEffect, useState } from "react";
import {
  AcceptButton,
  ButtonsSection,
  Card,
  LabelText,
  SectionTitle,
  TitleSection,
  ValueText,
  Wrapper,
} from "../Properties/Details/styles";
import requestAPI from "../../utils/requestAPI";
import settings from "../../apiConfigs/settings";
import { ReactComponent as Delete } from "../../assets/delete.svg";
import { ReactComponent as Edit } from "../../assets/edit.svg";
import { toast } from "react-toastify";
import DeleteModal from "../../designComponents/DeleteModal";
import Modal from "../../designComponents/Modal";
import LabelInputField from "../../designComponents/LabelInputField/LabelInputField";
import MediaUploader from "../../designComponents/MediaUpload/MediaUpload";
import { uploadFilesToS3OnlyKeys } from "../../utils/s3Upload";
import { getIconsUrl } from "../../utils/resizeImages";

function UtilityCategory() {
  const [categories, setCategories] = useState<
    { title: string[]; category: string; icon: string; _id: string }[]
  >([]);
  const [utilityProviders, setUtilityProviders] = useState<any[]>([]);

  const [uploadedFile, setUploadedFile] = useState<File | string | null>(null);
  const [categoryInformation, setCategoryInformation] = useState<{
    category: string;
  }>({ category: "" });
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [OpenDeleteModal, setOpenDeleteModal] = useState<string | null>(null);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const getUtilityCategories = async () => {
    const response = await requestAPI(settings.getUtilityCategories());
    setCategories(response.data);
  };
  const getUtilityProviders = async () => {
    const response = await requestAPI(settings.getUtilityProviders());
    setUtilityProviders(response.data);
  };
  const [titles, setTitles] = useState<string[]>([""]);
  useEffect(() => {
    getUtilityCategories();
    // getUtilityProviders();
  }, []);

  const handleToggle = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index); // Toggle category visibility
  };
  const handleDelete = async (id: string) => {
    try {
      await requestAPI(settings.deleteUtilityCategory(id));
      toast.success("Successfully Deleted");
      setOpenDeleteModal(null);
      getUtilityCategories();
    } catch (error: any) {
      toast.error("Could not delete" + " " + error.message);
    }
  };
  const handleAdd = async () => {
    let providedUrl;
    try {
      if (uploadedFile && typeof uploadedFile !== "string") {
        const uploadFiles = await uploadFilesToS3OnlyKeys({
          category: "assets",
          fileUri: [uploadedFile],
          assetsCategory: "Utility Categories",
        });
        if (uploadFiles && uploadFiles.length > 0) {
          providedUrl = uploadFiles[0];
          await requestAPI(
            settings.addUtilityCategory({
              category: categoryInformation.category,
              title: titles,
              icon: providedUrl,
            })
          );
        }
      } else if (typeof uploadedFile === "string") {
        providedUrl = uploadedFile;
        await requestAPI(
          settings.addUtilityCategory({
            category: categoryInformation.category,
            title: titles,
            icon: providedUrl,
          })
        );
      }
      toast.success("Successfully Added new category");
      setOpenModal(false);
      getUtilityCategories();
      setCategoryInformation({ category: "" });
      setTitles([""]);
    } catch (error: any) {
      toast.error("Could not add" + " " + error.message);
    }
  };
  const handleTitleChange = (index: number, value: string) => {
    const updatedTitles = [...titles];
    updatedTitles[index] = value;
    setTitles(updatedTitles);
  };
  const [openEditModal, setOpenEditModal] = useState<string | null>(null);
  const handleEdit = async (id: string) => {
    let providedUrl;
    try {
      if (uploadedFile && typeof uploadedFile !== "string") {
        const uploadFiles = await uploadFilesToS3OnlyKeys({
          category: "assets",
          fileUri: [uploadedFile],
          assetsCategory: "Utility Category",
        });
        if (uploadFiles && uploadFiles.length > 0) {
          providedUrl = uploadFiles[0];
          await requestAPI(
            settings.updateUtilityCategory({
              id: id,
              data: {
                category: categoryInformation.category,
                title: titles,
                icon: providedUrl,
              },
            })
          );
        }
      } else if (typeof uploadedFile === "string") {
        providedUrl = uploadedFile;
        await requestAPI(
          settings.updateUtilityCategory({
            id: id,
            data: {
              category: categoryInformation.category,
              title: titles,
              icon: providedUrl,
            },
          })
        );
      }
      toast.success("Successfully Edited category");
      setOpenEditModal(null);
      getUtilityCategories();
      setCategoryInformation({ category: "" });
      setTitles([""]);
    } catch (error: any) {
      toast.error("Could not add" + " " + error.message);
    }
  };
  const handleAddTitle = () => {
    setTitles([...titles, ""]);
  };
  return (
    <div>
      <Card style={{ margin: 0 }}>
        <TitleSection>
          <ButtonsSection>
            <SectionTitle>Utility Category</SectionTitle>
            <AcceptButton
              onClick={() => {
                setOpenModal(true);
              }}
            >
              Add Category
            </AcceptButton>
          </ButtonsSection>
        </TitleSection>
        {categories.length > 0 ? (
          categories.map((item, index) => {
            const isActive = activeIndex === index;
            return (
              <>
                <ButtonsSection
                  key={index}
                  style={{
                    background: "#e7e7e7",
                    padding: 10,
                    borderRadius: 6,
                    cursor: "pointer",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    transition: "box-shadow 0.3s ease",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: 40,
                      alignItems: "center",
                    }}
                    onClick={() => handleToggle(index)}
                  >
                    <img
                      width={40}
                      height={40}
                      src={getIconsUrl(item.icon)}
                      style={{ borderRadius: 40 }}
                      alt={`${item.title}`}
                    />
                    <LabelText>{item.category}</LabelText>
                  </div>

                  <div style={{ display: "flex", gap: 20, cursor: "pointer" }}>
                    <div
                      onClick={() => {
                        setOpenDeleteModal(item._id);
                      }}
                    >
                      <Delete fill="#7E7E7E"></Delete>
                    </div>
                    <div
                      onClick={() => {
                        setTitles(item.title);
                        setCategoryInformation({ category: item.category });
                        setOpenEditModal(item._id);
                        setUploadedFile(item.icon);
                      }}
                    >
                      <Edit fill="#7E7E7E"></Edit>
                    </div>
                  </div>
                </ButtonsSection>
                {isActive && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      backgroundColor: "#F9F9FD",
                      padding: 10,
                      gap: 20,
                      borderRadius: 8,
                    }}
                  >
                    {item.title.map((item, index) => {
                      return <LabelText>{item}</LabelText>;
                    })}
                  </div>
                )}
                {OpenDeleteModal === item._id && (
                  <DeleteModal
                    isOpen={true}
                    onClose={() => {
                      setOpenDeleteModal(null);
                    }}
                    itemName="Category"
                    title="Are you sure you want to delete this category?"
                    loading={false}
                    onDelete={() => {
                      handleDelete(item._id);
                    }}
                  ></DeleteModal>
                )}
                <Modal
                  isOpen={openEditModal === item._id}
                  onClose={() => {
                    setOpenEditModal(null);
                    setTitles([""]);
                    setCategoryInformation({ category: "" });
                  }}
                  halfWidth={true}
                  title="Edit Utility Category"
                >
                  <LabelInputField
                    name="Category"
                    label="Category Name"
                    value={categoryInformation.category}
                    onChange={(e) => {
                      setCategoryInformation({
                        category: e.target.value,
                      });
                    }}
                    style={{
                      label: {
                        fontSize: "14px",
                        fontWeight: "500px",
                        color: "#555A77",
                      },
                      input: {
                        height: 50,
                        border: "1px solid #F1EFFB",
                        padding: 8,
                        background: "#F1EFFB",
                        borderRadius: 6,
                        width: "100%",
                      },
                      container: {
                        display: "flex",
                        flexDirection: "column",
                        gap: 6,
                        paddingTop: 14,
                      },
                    }}
                  ></LabelInputField>

                  <ButtonsSection style={{ paddingTop: 10 }}>
                    <SectionTitle>Titles</SectionTitle>
                    <AcceptButton
                      onClick={() => {
                        handleAddTitle();
                      }}
                    >
                      Add title
                    </AcceptButton>
                  </ButtonsSection>
                  <div style={{ display: "flex", gap: 6, paddingTop: 14 }}>
                    {titles.map((title, index) => (
                      <div key={index} style={{ position: "relative" }}>
                        {index > 0 && (
                          <div
                            style={{
                              position: "absolute",
                              top: "0px",
                              right: "0px",
                              cursor: "pointer",
                              padding: 10,
                              fontSize: "20px",
                            }}
                            onClick={() => {
                              const updatedTitles = [...titles];
                              updatedTitles.splice(index, 1);
                              setTitles(updatedTitles);
                            }}
                          >
                            &times;
                          </div>
                        )}
                        <LabelInputField
                          key={index}
                          name={`Title-${index}`}
                          label={`Title Name ${index + 1}`}
                          value={title}
                          onChange={(e) =>
                            handleTitleChange(index, e.target.value)
                          }
                          style={{
                            label: {
                              fontSize: "14px",
                              fontWeight: "500px",
                              color: "#555A77",
                            },
                            input: {
                              height: 50,
                              border: "1px solid #F1EFFB",
                              padding: 8,
                              background: "#F1EFFB",
                              borderRadius: 6,
                              width: "100%",
                            },
                            container: {
                              display: "flex",
                              flexDirection: "column",
                              gap: 6,
                              paddingTop: 14,
                            },
                          }}
                        />
                      </div>
                    ))}
                  </div>
                  <MediaUploader
                    label="Icon"
                    image={
                      uploadedFile && typeof uploadedFile === "string"
                        ? [uploadedFile]
                        : []
                    }
                    onChange={(e) => {
                      const file = e.target.files?.[0] || null;
                      setUploadedFile(file);
                    }}
                    style={{
                      container: { paddingTop: 10, gap: 6, marginBottom: 10 },
                      label: { paddingBottom: 10, color: "#555A77" },
                      dropzone: { background: "#F1EFFB" },
                    }}
                  ></MediaUploader>
                  <AcceptButton
                    onClick={() => {
                      handleEdit(item._id);
                    }}
                  >
                    Edit
                  </AcceptButton>
                </Modal>
              </>
            );
          })
        ) : (
          <ValueText>No Category</ValueText>
        )}
      </Card>
      <Modal
        isOpen={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
        halfWidth={true}
        title="Add Utility Category"
      >
        <LabelInputField
          name="Category"
          label="Category Name"
          onChange={(e) => {
            setCategoryInformation({
              category: e.target.value,
            });
          }}
          style={{
            label: {
              fontSize: "14px",
              fontWeight: "500px",
              color: "#555A77",
            },
            input: {
              height: 50,
              border: "1px solid #F1EFFB",
              padding: 8,
              background: "#F1EFFB",
              borderRadius: 6,
              width: "100%",
            },
            container: {
              display: "flex",
              flexDirection: "column",
              gap: 6,
              paddingTop: 14,
            },
          }}
        ></LabelInputField>
        <ButtonsSection style={{ paddingTop: 10 }}>
          <SectionTitle>Titles</SectionTitle>
          <AcceptButton
            onClick={() => {
              handleAddTitle();
            }}
          >
            Add title
          </AcceptButton>
        </ButtonsSection>
        <div style={{ display: "flex", gap: 6, paddingTop: 14 }}>
          {titles.map((title, index) => (
            <div key={index} style={{ position: "relative" }}>
              {index > 0 && (
                <div
                  style={{
                    position: "absolute",
                    top: "0px",
                    right: "0px",
                    cursor: "pointer",
                    padding: 10,
                    fontSize: "20px",
                  }}
                  onClick={() => {
                    const updatedTitles = [...titles];
                    updatedTitles.splice(index, 1);
                    setTitles(updatedTitles);
                  }}
                >
                  &times;
                </div>
              )}
              <LabelInputField
                key={index}
                name={`Title-${index}`}
                label={`Title Name ${index + 1}`}
                value={title}
                onChange={(e) => handleTitleChange(index, e.target.value)}
                style={{
                  label: {
                    fontSize: "14px",
                    fontWeight: "500px",
                    color: "#555A77",
                  },
                  input: {
                    height: 50,
                    border: "1px solid #F1EFFB",
                    padding: 8,
                    background: "#F1EFFB",
                    borderRadius: 6,
                    width: "100%",
                  },
                  container: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 6,
                    paddingTop: 14,
                  },
                }}
              />
            </div>
          ))}
        </div>
        <MediaUploader
          label="Icon"
          onChange={(e) => {
            const file = e.target.files?.[0] || null;
            setUploadedFile(file);
          }}
          style={{
            container: { paddingTop: 10, gap: 6, marginBottom: 10 },
            label: { paddingBottom: 10, color: "#555A77" },
            dropzone: { background: "#F1EFFB" },
          }}
        ></MediaUploader>
        <AcceptButton
          onClick={() => {
            handleAdd();
          }}
        >
          Add
        </AcceptButton>
      </Modal>
    </div>
  );
}

export default UtilityCategory;
